import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  author: string;
  product?: string;
}
const TestimonialCard = ({
  quote,
  author,
  product
}: TestimonialProps) => <motion.div whileHover={{
  y: -5
}} className="bg-white p-8 rounded-xl border border-border shadow-sm" data-id="element-260">
    <div className="flex mb-4" data-id="element-261">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-262" />)}
    </div>
    <p className="text-ink italic mb-6 text-base md:text-lg leading-relaxed" data-id="element-263">
      "{quote}"
    </p>
    <div data-id="element-264">
      <p className="font-bold text-ink font-serif" data-id="element-265">{author}</p>
      {product && <p className="text-xs text-primary font-medium mt-1 uppercase tracking-wider" data-id="element-266">
          {product}
        </p>}
    </div>
  </motion.div>;
export function TestimonialsFirstSet() {
  const testimonials = [{
    quote: 'En la primera semana identifiqué $90.000 que se me iban sin darme cuenta. Nunca pensé que ordenar mi plata iba a ser tan simple y tan brutal al mismo tiempo.',
    author: 'Luciana M. — Buenos Aires'
  }, {
    quote: 'El tomo de inversiones me cambió la cabeza. Siempre creí que invertir era para gente con mucha plata. Ahora tengo mis primeros CEDEARs con $50.000.',
    author: 'Rodrigo P. — Rosario'
  }, {
    quote: 'Llevaba 3 años llegando justo a fin de mes. Con el sistema de los 5 bloques empecé a sobrar plata por primera vez. Increíble lo simple que era.',
    author: 'Mariana G. — Córdoba'
  }];
  return <section className="bg-cream py-16 px-4" data-id="element-267">
      <div className="max-w-6xl mx-auto" data-id="element-268">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-269">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-270" />)}
        </div>
      </div>
    </section>;
}
export function TestimonialsSecondSet() {
  const testimonials = [{
    quote: 'Tenía miedo de meterme en inversiones. Con el Tomo 4 entendí todo en una tarde. Compré mis primeros CEDEARs esa misma semana.',
    author: 'Cecilia R. — Mendoza',
    product: 'Dominio + Portafolios Maestros'
  }, {
    quote: 'El tomo de Blindaje Criollo me abrió los ojos sobre el sistema bancario argentino. Cancelé dos seguros y recuperé $8.500 por mes.',
    author: 'Roberto M. — Buenos Aires',
    product: 'Dominio Financiero'
  }, {
    quote: 'Llegaba justo todos los meses y creía que era porque ganaba poco. Con el Checklist Anti-Fugas encontré $65.000 que se me iban sin verlos.',
    author: 'Sofía C. — La Plata',
    product: 'Dominio Financiero'
  }, {
    quote: 'El Plan del 1% del upsell fue lo que necesitaba. Empecé con $80.000 y en 3 meses tengo $142.000.',
    author: 'Pablo A. — Neuquén',
    product: 'Dominio + Portafolios Maestros'
  }];
  return <section className="bg-surface py-16 px-4 border-y border-border" data-id="element-271">
      <div className="max-w-6xl mx-auto" data-id="element-272">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-ink mb-12 font-serif" data-id="element-273">
          ❤️ MÁS PERSONAS QUE YA LO TIENEN
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-274">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-275" />)}
        </div>
      </div>
    </section>;
}